import type { RouteObject } from "react-router-dom";
import { useParams } from "react-router-dom";
import { ThemeCreatePage } from "./pages/ThemeCreatePage";
import { ThemeDetailPage } from "./pages/ThemeDetailPage";
import { ThemesPage } from "./pages/ThemesPage";
import { useLocale } from "@admin/app/locale";

function AdminThemesRoute() {
  const locale = useLocale();
  return <ThemesPage locale={locale} />;
}

function AdminThemeCreateRoute() {
  const locale = useLocale();
  return <ThemeCreatePage locale={locale} />;
}

function AdminThemeDetailRoute() {
  const locale = useLocale();
  const { id = "" } = useParams();
  return <ThemeDetailPage locale={locale} themeId={id} />;
}

export const themeRoutes: RouteObject[] = [
  {
    path: "themes",
    element: <AdminThemesRoute />,
  },
  {
    path: "themes/new",
    element: <AdminThemeCreateRoute />,
  },
  {
    path: "themes/:id",
    element: <AdminThemeDetailRoute />,
  },
];
